import React, { useState } from "react";
import { SpotGear, Info } from "design_system/Icon";
import classNames from "classnames";

type BannerStyle = "gray" | "blue";
type Props = {
    bannerStyle?: BannerStyle;
    title?: string;
    content: string;
    showIcon?: boolean;
    onClose?: () => void;
};

const BLUE = "blue";
const GRAY = "gray";

export const WelcomeBanner = ({
    bannerStyle = BLUE,
    title,
    content,
    onClose,
    showIcon = true,
}: Props) => {
    const [visible, setVisible] = useState(true);
    if (visible) {
        return (
            <div
                className={classNames({
                    "bg-primary-3667e9 text-white": bannerStyle === BLUE,
                    "bg-gray-e7e9ef text-black": bannerStyle === GRAY,
                })}
            >
                <div className="max-w-1100 m-auto p-16">
                    <div className="flex">
                        <div className="w-11/12">
                            <div className="flex flex-col s768:flex-row">
                                <div className="w-auto mr-0 py-12 s768:mr-12 s768:py-0">
                                    {showIcon &&
                                        (bannerStyle === BLUE ? (
                                            <SpotGear size={40} />
                                        ) : (
                                            <Info size={40} color="#13126C" />
                                        ))}
                                </div>
                                <div className="w-auto s768:w-11/12">
                                    <div className="text-1_25">
                                        <strong>{title}</strong>
                                    </div>
                                    <div
                                        className="text-1"
                                        dangerouslySetInnerHTML={{ __html: content }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/12 pr-8 text-right">
                            <button
                                className="text-1"
                                onClick={() => {
                                    setVisible(false);
                                    onClose && onClose();
                                }}
                            >
                                &#x2715;
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};
